'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

import scheduledJobGroupFormHtmlUrl from '../views/scheduledJobGroupForm.html';
import scheduledJobFormHtmlUrl from '../views/scheduledJobForm.html';

angular.module('scheduledJobs.ctrls', [])
    .controller('ScheduledJobGroupsController', ['$scope', '$modal', '$ioAlert', '$confirm', '$state', 'UserService', '$rootScope', 'ScheduleJobsService', 'FormService', function($scope, $modal, $ioAlert, $confirm, $state, UserService, $rootScope, ScheduleJobsService, FormService) {
        $scope.scheduledJobGroups = [];
        $scope.workflowTypes = [];
        $scope.workflowActions = [];
        $scope.queryKeys = [];
        $scope.timezones = [];
        $scope.disableBtnAction = false;

        $scope.getScheduledJobGroups = function() {
            $rootScope.loadertitle = "Fetching Schedule Job Groups";
            $rootScope.loadingInProgress = true;
            ScheduleJobsService.getScheduledJobGroups().then(function(success) {
                if (success.jobGroups) {
                    $scope.scheduledJobGroups = success.jobGroups;
                    for (var i = 0, len = $scope.scheduledJobGroups.length; i < len; i++) {
                        $scope.scheduledJobGroups[i].filterActive = 1;
                    }
                    $rootScope.loadingInProgress = false;
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not getting scheduled job groups.', 'error');
                $rootScope.loadingInProgress = false;
            });
        }

        $scope.addJobGroup = function() {
            $scope.viewJobGroup();
        }

        $scope.importJobGroup = function() {
            if ($scope.uploadMedia.file && $scope.uploadMedia.file.length) {
                ScheduleJobsService.importJobGroup($scope.uploadMedia.file).then(function (data) {
                    if (!data.data.result.hasOwnProperty('errors')) {
                        $ioAlert.show('', 'Job group imported successfully', 'success');
                        $scope.getScheduledJobGroups();
                    } else {
                        for (var i = 0, len = data.data.result.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', data.data.result.errors[i], 'error');
                        }
                        console.log(data.data.result.errors);
                    }

                }, function (error) {
                    $scope.lockedButton = false;
                    $ioAlert.show('Error!', 'Error importing job group: ' + error, 'error');
                });
            }
        };

        $scope.editJobGroup = function(jobGroup) {
            $scope.viewJobGroup(jobGroup);
        }

        $scope.exportJobGroup = function (jobGroup) {
            ScheduleJobsService.exportJobGroup(jobGroup).then(function(response) {
                if (!response.hasOwnProperty('errors')) {
                    let csvString = response;
                    let a = $('<a/>', {
                        style: 'display:none',
                        href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
                        download: 'jobgroup_' + jobGroup.id + '.csv'
                    }).appendTo('body');
                    a[0].click();
                    a.remove();
                    $ioAlert.show('', 'File exported successfully', 'success');
                } else {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', response.errors[i], 'error');
                    }
                    console.log(response.errors);
                }

            }, function(error) {
                $scope.lockedButton = false;
                $ioAlert.show('Error!', 'Error exporting job group ' + jobGroup.id + ': ' + error, 'error');
            });
        }

        $scope.deleteJobGroup = function(jobGroup) {
            var index = $scope.scheduledJobGroups.indexOf(jobGroup);
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Job Group?'
            }).then(function() {
                ScheduleJobsService.deleteJobGroup(jobGroup).then(function(response) {
                    if (response.errors) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show('Job Group Deleted', 'Job Group has been deleted successfully', 'success');
                        $scope.scheduledJobGroups.splice(index, 1);
                    }
                });
            });
        }

        $scope.viewJobGroup = function(jobGroup) {
            $scope.isNew = (jobGroup == null);
            $modal.open({
                controller: function($scope, $modalInstance, jobGroup, timeZones, UserService, ScheduleJobsService, $ioAlert, $http) {
                    $scope.groupObj = {};
                    $scope.timezones = timeZones;

                    if (jobGroup) {
                        $scope.groupObj.id = jobGroup.id;
                        $scope.groupObj.name = jobGroup.name;
                        $scope.groupObj.timezone = jobGroup.timezone;
                        $scope.titleText = "Update Job Group";
                    } else {
                        $scope.titleText = "Create New Job Group";
                    }
                    $scope.save = function(groupForm) {
                        if (groupForm.$valid) {
                            if (jobGroup) {
                                ScheduleJobsService.updateJobGroup($scope.groupObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.jobGroup) {
                                        $modalInstance.close(response.jobGroup);
                                    }
                                }, function(error) {
                                    console.log("Error updating job group");
                                });
                            } else {
                                ScheduleJobsService.addJobGroup($scope.groupObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.jobGroup) {
                                        $modalInstance.close(response.jobGroup);
                                    }
                                }, function(error) {
                                    console.log("Error adding job group");
                                });
                            }
                        }
                    };
                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }
                },
                templateUrl: scheduledJobGroupFormHtmlUrl,
                resolve: {
                    jobGroup: function() {
                        return jobGroup;
                    },
                    timeZones: function() {
                        return $scope.timezones;
                    }
                },
                backdrop: 'static'
            }).result.then(function(jobGroupObj) {
                if ($scope.isNew) {
                    $scope.scheduledJobGroups.push(jobGroupObj);
                    $ioAlert.show('New Job Group', 'New Job Group has been added successfully', 'success');
                } else {
                    $scope.scheduledJobGroups[$scope.scheduledJobGroups.indexOf(jobGroup)] = jobGroupObj;
                    $ioAlert.show('Update Job Group', 'Job Group has been updated successfully', 'success');
                }
            }, function(cancel) {

            });
        }

        $scope.toggleJobGroup = function(ev, jobGroup) {
            $(ev.target).siblings(':last').slideToggle(200);
            if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.target).removeClass('fa-chevron-right');
                $(ev.target).addClass('fa-chevron-down');
                $scope.getScheduledJobsByGroup(jobGroup);
            } else {
                $(ev.target).removeClass('fa-chevron-down');
                $(ev.target).addClass('fa-chevron-right');
            }
        }

        $scope.addScheduledJob = function(jobGroup) {
            $scope.viewScheduledJob(jobGroup);
        }

        $scope.editScheduledJob = function(jobGroup, job) {
            $scope.viewScheduledJob(jobGroup, job);
        }

        $scope.viewScheduledJob = function(jobGroup, job) {
            $scope.jobGroup = jobGroup;
            $scope.isNew = (job == null);
            $modal.open({
                controller: function($scope, $modalInstance, job, UserService, formData, ScheduleJobsService, $ioAlert) {
                    $scope.jobObj = {};
                    $scope.workflowTypes = formData.workflowTypes;
                    $scope.workflowActions = formData.workflowActions;
                    $scope.queryKeys = formData.queryKeys;
                    if (job) {
                        $scope.jobObj.id = job.id;
                        $scope.jobObj.groupId = job.group_id;
                        $scope.jobObj.name = job.name;
                        $scope.jobObj.description = job.description;
                        $scope.jobObj.active = (job.active == "1") ? true : false;
                        $scope.jobObj.workflowActionId = job.workflow_action_id;
                        $scope.jobObj.workflowTypeId = job.workflow_type_id;
                        $scope.jobObj.queryKey = job.query_key;
                        $scope.jobObj.dateOffset = job.date_offset;
                        $scope.jobObj.additionalParams = job.additional_parameters;
                        $scope.additionalParams = [];
                        if (job.additional_parameters) {
                            var additionalParams = angular.fromJson(job.additional_parameters);
                            additionalParams = angular.isObject(additionalParams) ? additionalParams : {};
                            for (var iKey in additionalParams) {
                                $scope.additionalParams.push({
                                    key: iKey,
                                    val: additionalParams[iKey]
                                });
                            }
                        }
                        $scope.titleText = "Update Job";
                    } else {
                        $scope.jobObj.groupId = formData.jobGroup.id;
                        $scope.additionalParams = [];
                        $scope.titleText = "Create New Job";
                    }
                    $scope.save = function(jobForm) {
                        var additionalParams = {};
                        $scope.additionalParams.forEach(function(item) {
                            if (additionalParams[item.key]) {
                                $ioAlert.show('Error', "Duplicate key entered in additional parameters");
                                jobForm.$valid = false;
                            }
                            additionalParams[item.key] = item.val;
                        });
                        if (jobForm.$valid) {
                            $scope.jobObj.active = ($scope.jobObj.active == true) ? 1 : 0;
                            $scope.jobObj.additionalParams = angular.toJson(additionalParams);
                            if (job) {
                                ScheduleJobsService.updateJob($scope.jobObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.job) {
                                        $modalInstance.close(response.job);
                                    }
                                }, function(error) {
                                    console.log("Error updating job group");
                                });
                            } else {
                                ScheduleJobsService.addJob($scope.jobObj).then(function(response) {
                                    if (response.errors) {
                                        for (var i = 0, len = response.errors.length; i < len; i++) {
                                            $ioAlert.show('Error', response.errors[i]);
                                        }
                                    }
                                    if (response.job) {
                                        $modalInstance.close(response.job);
                                    }
                                }, function(error) {
                                    console.log("Error adding job group");
                                });
                            }
                        }
                    };
                    $scope.cancel = function() {
                        $modalInstance.dismiss();
                    }
                    $scope.addNewParam = function() {
                        $scope.additionalParams.push({
                            key: "",
                            val: ""
                        });
                    }
                    $scope.removeParam = function(item) {
                        var index = $scope.additionalParams.indexOf(item);
                        $scope.additionalParams.splice(index, 1);
                    }
                },
                templateUrl: scheduledJobFormHtmlUrl,
                resolve: {
                    job: function() {
                        return job;
                    },
                    formData: function() {
                        return {
                            jobGroup: jobGroup,
                            workflowTypes: $scope.workflowTypes,
                            workflowActions: $scope.workflowActions,
                            queryKeys: $scope.queryKeys
                        }
                    }
                },
                backdrop: 'static'
            }).result.then(function(jobObj) {
                $scope.getScheduledJobsByGroup($scope.jobGroup);
                if ($scope.isNew) {
                    $ioAlert.show('New Job Group', 'New Job Group has been added successfully', 'success');
                } else {
                    $ioAlert.show('Update Job Group', 'Job Group has been updated successfully', 'success');
                }
            }, function(cancel) {

            });
        }

        $scope.removeScheduledJob = function(jobGroup, job) {
            ScheduleJobsService.deleteJob({
                id: job.id
            }).then(function(response) {
                $scope.getScheduledJobsByGroup(jobGroup);
            }, function(error) {
                console.log("Error deleting job");
            });
        }

        $scope.getScheduledJobsByGroup = function(jobGroup) {
            jobGroup.filterActive = 1;
            ScheduleJobsService.getScheduledJobsByGroup(jobGroup).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('Error', response.errors[i]);
                    }
                } else {
                    for (var i = 0, len = response.jobs.length; i < len; i++) {
                        response.jobs[i].params = [];
                        var workflowAction = _.find($scope.workflowActions, {
                            id: response.jobs[i].workflow_action_id
                        });
                        response.jobs[i].workflow_action_name = (workflowAction) ? workflowAction.name : "";
                        var workflowType = _.find($scope.workflowTypes, {
                            id: response.jobs[i].workflow_type_id
                        });
                        response.jobs[i].workflow_type_name = (workflowType) ? workflowType.name : "";
                        if (response.jobs[i].additional_parameters) {
                            response.jobs[i].params = angular.fromJson(response.jobs[i].additional_parameters);
                        }
                    }
                    $scope.scheduledJobGroups[$scope.scheduledJobGroups.indexOf(jobGroup)].jobs = response.jobs;
                }
            }, function(error) {
                console.log("Error getting jobs");
            });
        }

        /*
        * Handle get instance lock configuration
        */
        var getInstanceLockConfig = function() {
            FormService.getInstanceLockConfig().then(function(data) {
                if(data.instanceLocked) {
                    $scope.disableBtnAction = true;
                } else {
                    $scope.disableBtnAction = false;
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
        UserService.adjustStickyHeaderWindowResize();
        var init = function() {
            $scope.getScheduledJobGroups();
            getInstanceLockConfig();
            UserService.adjustStickyHeader();
            ScheduleJobsService.getWorkflowTypes().then(function(success) {
                if (success.workflowTypes) {
                    $scope.workflowTypes = success.workflowTypes;
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not getting workflow types.', 'error');
            });
            ScheduleJobsService.getWorkflowActions().then(function(success) {
                if (success.workflowActions) {
                    $scope.workflowActions = success.workflowActions;
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not getting workflow actions.', 'error');
            });
            ScheduleJobsService.getQueryKeys().then(function(success) {
                if (success.queryKeys) {
                    $scope.queryKeys = success.queryKeys;
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not getting query keys.', 'error');
            });
            ScheduleJobsService.getTimeZones().then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('Error', response.errors[i]);
                    }
                } else {
                    $scope.timezones = response;
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Could not getting timezones.', 'error');
            });
        };
        init();
    }]);